<template>
  <div ref="searchBox" v-if="showModal" class="search search-box">
    <div class="card no-hover bg-blurry">
      <div class="card-header border-none pt-4 text-center">
        <slot name="header"></slot>
      </div>
      <div class="card-body">
        <slot name="body"></slot>
      </div>
      <div v-if="$slots['footer']" class="card-footer text-center pb-4">
        <slot name="footer"></slot>
      </div>
    </div>
    <div class="overlay" @click="showModal = false"></div>
  </div>
</template>
<script setup lang="ts">

  const props = defineProps({
    show: {
      type: Boolean,
      default: false,
    }
  });

  const showModal = ref(props.show);

  const emit = defineEmits(['update-show']);

  watch(showModal, (newVal) => {
    if (!newVal) {
      emit('update-show', newVal);
    }
  });

  watch(() => props.show, (newVal) => {
    showModal.value = newVal;
  });
</script>